import { colors } from "@/styles/utils/vars"
import { Icon } from "@/ui/Icon"
import { Typography } from "@/ui/Typography/Typography"
import { DescriptionProduct } from "./Description"
import { Description, DescriptionProductWrapper } from "./StyledDetail"

const DescriptionStatic = () => {
  return (
    <>
      <Description>
        <Icon NameIcon={"Car"} fill={colors.brand.yellow} />
        <Typography variant={"span"}>
          <b>Доставка курьером 1-3 дня.</b>
        </Typography>
      </Description>

      <DescriptionProductWrapper>
        <DescriptionProduct
          TypographyVariant={"p12"}
          heightPreview={"m"}
          description={`
            Если в вашем городе есть наш филиал, доставка бесплатная.
            Осуществляется нашими курьерами.
            Если вы заказываете доставку в город, где нет нашего филиала, доставка
            осуществляется через транспортные компании после полной оплаты товара.
            Мы работаем со: Сдек, Пэк, Деловыми Линиями, Байкал сервис, Кит,
            Энергия, Авито доставка, ЖелДорЭкспедиция, Мэйджик транс.
            Если габариты заказа составляют более 1 паллета, можем отправить
            сборным грузом.
            Стоимость доставки транспортной компании зависит от габаритов груза и
            расстояния транспортировки. Рассчитывается индивидуально. Вы можете
            оформить заказ, далее мы вам просчитаем стоимость доставки и вы
            примите решение оплачивать заказ, либо отказаться от него.
            
            Доставка до транспортной компании бесплатная.`}
        />
      </DescriptionProductWrapper>

      <Description>
        <Icon NameIcon={"Verified"} fill={colors.brand.yellow} />
        <Typography variant={"span"}>
          <b>Гарантия легкого возврата:</b> до 14 дней на возврат, полная
          гарантия.
        </Typography>
      </Description>
    </>
  )
}

DescriptionStatic.displayName = "DescriptionStatic"

export { DescriptionStatic }
